import { FAQCollection } from '@shared/components/chatbot/chatbot.model';

export const faqCollections: FAQCollection[] = [
  {
    name: 'Investing in Greece',
    description: 'Find answers about investing with Seedio in Greece',
    numberOfArticles: 2,
    articleCollections: [
      {
        name: 'General',
        description: '',
        articles: [
          {
            id: '1',
            title: 'How does it work?',
            contentHTML: `
                <article class="flex flex-col gap-5 font-normal text-sm text-light-300 p-5">
                  <h1 class="font-bold text-2xl">How does it work?</h1>

                  <p>
                    Investing in a Greek property with Seedio is quite simple, however there
                    are few steps that occur in order for you to have a piece of the pie!
                  </p>

                  <ol class="flex flex-col gap-5 list-decimal pl-7">
                    <li>
                      <p><b>Property is listed on Seedio</b></p>
                      <p>
                        A property is listed on Seedio in order to raise funds for the
                        purchase. It's usually listed for 30 days, however they tend to get
                        fully funded quicker!
                      </p>
                    </li>
                    <li>
                      <p><b>Funds raised</b></p>
                      <p>
                        Once enough funds are raised, the funding is closed and the deal moves
                        to its final stages.
                      </p>
                    </li>
                    <li>
                      <p><b>SPV created </b></p>
                      <p>
                        A Special Purpose Vehicle (SPV) is created in the DIFC in order to
                        incorporate and ensure that all investors in the property are legally
                        registered to the property through their ownership of shares in the
                        SPV. The SPV listed as the owner on the title deed.
                      </p>
                    </li>
                    <li>
                      <p><b>Property documents distributed</b></p>
                      <p>
                        All investors will receive their title deeds and share certificates
                        within a few weeks of the funding closing as proof of ownership of the
                        property.
                      </p>
                    </li>
                    <li>
                      <p><b>Rental payments begin</b></p>
                      <p>
                        Once the process is complete, investors will begin to receive their
                        rental payments.
                      </p>
                    </li>
                  </ol>

                  <p>
                    The tentative dates for all steps in the process are provided in each
                    listing.
                  </p>
                </article>  
              `,
          },
        ],
      },
      {
        name: 'Investing',
        description:
          'All your questions about how to invest using Seedio, answered!',
        articles: [
          {
            id: '2',
            title: 'How much can I invest?',
            contentHTML: `
              <article class="flex flex-col gap-5 font-normal text-sm text-light-300 p-5">
                <h1 class="font-bold text-2xl">How much can I invest?</h1>

                <div class="flex flex-col gap-5">
                  <p>
                    Seedio aims to make investing affordable and accessible. That's why you
                    can start with as little as 100 EUR.
                  </p>

                  <p>
                    However, the following limits are applicable depending on your
                    classification.
                  </p>

                  <div>
                    <p>Retail Clients:</p>
                    <ol class="list-disc pl-7">
                      <li>Property limit: 50,000 EUR per property</li>

                      <li>Annual limit: 200,000 EUR</li>
                    </ol>
                  </div>

                  <div>
                    <p>Professional Clients:</p>
                    <ol class="list-disc pl-7">
                      <li>Property limit: 33% of any single property</li>

                      <li>Annual limit: Not applicable</li>
                    </ol>
                  </div>

                  <p>
                    Lastly, the availability of investments in a given opportunity is
                    limited to the total target amount being raised for that property.
                  </p>

                  <p>
                    In other words, if you are looking to invest in a property with a total
                    investment cost of 50,000 EUR at the time when it is 90% sold, you may
                    not invest more than 5,000 EUR, which is the remaining 10% share that is
                    available for investment at that time.
                  </p>
                </div>
              </article>
            `,
          },
        ],
      },
    ],
  },
  {
    name: 'About Seedio',
    description: 'Learn more about Seedio and how to get started',
    numberOfArticles: 2,
    articleCollections: [
      {
        name: 'General',
        description: '',
        articles: [
          {
            id: '3',
            title: 'What is Seedio?',
            contentHTML: `
              <article class="flex flex-col gap-5 font-normal text-sm text-light-300 p-5">
                <h1 class="font-bold text-2xl">What is Seedio?</h1>

                <div class="flex flex-col gap-5">
                  <p>
                    Seedio is a leading real estate investment platform, designed to make
                    building wealth through real estate accessible to everyone. With a
                    starting investment as low as 100 EUR, Seedio democratizes access to
                    exclusive, high-growth real estate markets, offering a fully digital,
                    hassle-free experience.
                  </p>

                  <div>
                    <p><b>Where can I invest with Seedio?</b></p>
                    <p>
                      Seedio offers investment opportunities accessible within the same app.
                    </p>
                  </div>

                  <div>
                    <p><b>How do I get started?</b></p>
                    <p>
                      Signing up with Seedio is simple! Create an account, browse detailed
                      investment opportunities, complete the onboarding process, fund your
                      wallet, and start investing all through a seamless, digital platform.
                    </p>
                  </div>
                </div>
              </article>
            `,
          },
          {
            id: '4',
            title: 'What am I investing in?',
            contentHTML: `
              <article class="flex flex-col gap-5 font-normal text-sm text-light-300 p-5">
                <h1 class="font-bold text-2xl">What am I investing in?</h1>

                <div class="flex flex-col gap-5">
                  <p>
                    When you invest in a property on Seedio, you are investing in the shares
                    of an Special Purpose Vehicle (SPV) that will own the title deed to the
                    subject property. All investors in a property will be issued shares in
                    the SPV in proportion to the amount they invested.
                  </p>

                  <p>
                    Please note all SPVs that hold title to properties bought through Seedio
                    will be administered by Seedio over the full term of these investments.
                    Please refer to the Terms & Conditions for more details.
                  </p>
                </div>
              </article>
            `,
          },
        ],
      },
    ],
  },
];
